import React from "react";
import { Release, Issue } from "components/ReleaseNotesTemplate";

// eslint-disable-next-line react/prop-types
const ReleaseNotes = ({ showVersion }) => (
  <div>
    <Release version="2.17" date="Jan 14, 2026" heading="Gundi Gal">
      <Issue type="new feature">
        Wirewalker CTD data processing with cast_id handling and site search
        functionality [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/1566">
          #1566
        </a>
        ]{" "}
      </Issue>
      <Issue type="new feature">
        S3 streaming architecture migration from FUSE-mounted buckets to direct
        streaming [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/1591">
          #1591
        </a>
        ]{" "}
      </Issue>
      <Issue type="new feature">
        MinIO service for local S3 emulation in development environment{" "}
      </Issue>
      <Issue type="improvement">
        Increased API container memory from 2GB to 6GB{" "}
      </Issue>
      <Issue type="improvement">
        Increased Node.js heap size from 2GB to 4GB{" "}
      </Issue>
      <Issue type="improvement">
        Increased rsk-converter-api memory to 4GB{" "}
      </Issue>
      <Issue type="improvement">
        Enhanced nginx timeout handling (proxy_read_timeout: 30m){" "}
      </Issue>
      <Issue type="improvement">
        Upgraded PostgreSQL from 13-3.1 to 16-3.4{" "}
      </Issue>
      <Issue type="improvement">
        Added CTD_MAX_STREAM_CONCURRENCY environment variable for concurrent
        frame processing (default: 10){" "}
      </Issue>
      <Issue type="improvement">
        Added CTD_STREAM_BACKOFF environment variable for concurrency backoff
        (default: 1000μs){" "}
      </Issue>
      <Issue type="improvement">
        Added CTD_SITE_SEARCH_DISTANCE environment variable for site name search
        radius (default: 500m){" "}
      </Issue>
      <Issue type="improvement">
        Removed CTD_DIR environment variable (no longer needed with S3
        streaming){" "}
      </Issue>
      <Issue type="improvement">
        Added PR tagging to container builds (type=ref,event=pr){" "}
      </Issue>
      <Issue type="improvement">
        Added docker log dumping on test failures{" "}
      </Issue>
      <Issue type="improvement">
        Optimized GitHub Actions by removing yarn cache steps{" "}
      </Issue>
      <Issue type="improvement">
        Added hostedtoolcache cleanup to save space{" "}
      </Issue>
      <Issue type="improvement">
        Updated README with improved CTD processing flow diagram{" "}
      </Issue>
      <Issue type="improvement">
        Enhanced mermaid diagrams with wirewalker processing details{" "}
      </Issue>
      <Issue type="improvement">Updated contact information </Issue>
      <Issue type="improvement">
        Clarified S3 bulk download endpoint documentation{" "}
      </Issue>
      <Issue type="improvement">
        Improved docker-compose-local-overrides.yml configuration{" "}
      </Issue>
      <Issue type="improvement">
        Enhanced logging (disabled health check logging){" "}
      </Issue>
      <Issue type="bug">Fixed RBR timezone parsing </Issue>
      <Issue type="bug">Improved error handling for CTD processing </Issue>
      <Issue type="bug">
        Added additional test coverage for RBR timezone parsing{" "}
      </Issue>
    </Release>
    <Release
      version="2.16"
      date="Oct 31st 2023"
      heading="Nightjar Osmole"
      showVersion={showVersion}
    >
      <Issue type="new feature">
        Dynamic graph on Data Tools Download Page [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/251)">
          #251
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/181">
          #181
        </a>
        ]{" "}
      </Issue>
      <Issue type="new feature">
        Spatial Search on Data Tools Download Page [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/245">
          {" "}
          #245
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/201">
          {" "}
          #201
        </a>
        ]{" "}
      </Issue>
      <Issue type="new feature">
        Spatial Map Display on Data Tools Download Page [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/241">
          {" "}
          #241
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/201">
          {" "}
          #201
        </a>
        ]{" "}
      </Issue>
      <Issue type="new feature">
        EIMS admins can now apply corrections to DeviceMagic form payloads
        through the EIMS data portal [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/186">
          #186
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Fix clear button for selected timezone [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/255">
          {" "}
          #255
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/252">
          {" "}
          #252
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Add unit tests for plot utility functions [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/254">
          #254
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Integrate Sentry Session Replay to improve debugging process [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/247">
          {" "}
          #247
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/243">
          {" "}
          #243
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Add button to reset ctd download form fields [{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/242)">
          #242
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/185">
          {" "}
          #185
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Reword &apos;Files Contain Static Casts&apos; toggle label in CTD Upload
        page to be more accurate of what the toggle does [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/239">
          #239
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        Clean up CTD data views ctd.ctd_file_cast_* [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/914"> #914</a>{" "}
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/384">
          #384
        </a>
        ]{" "}
      </Issue>
      <Issue type="improvement">
        For CTD forms, Generate warning for casts more then 1km from site and
        block casts more then 4km from site [
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/368">
          #368
        </a>
        ]{" "}
      </Issue>
      <Issue type="bug">
        Corrected issue on CTD download page during processed files sb selection
        [{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/225">
          {" "}
          #225
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/219">
          {" "}
          #219
        </a>
        ]{" "}
      </Issue>
      <Issue type="bug">
        Add flowmeter calibrations to zooplankton sample views that need it [
        <a href="https://github.com/HakaiInstitute/hakai-database/pull/390">
          #390
        </a>
        ]{" "}
      </Issue>
      <Issue type="bug">
        Fixed broken Hakai Logo on Matrix Viewer and Historical Matrix [
        <a href="https://github.com/HakaiInstitute/oceanography_QC/issues/57">
          #57
        </a>
        ]{" "}
      </Issue>
      <Issue type="bug">
        Update querystring imports and remove Webpack fallback [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/250">
          #250
        </a>
        ]{" "}
      </Issue>
      <Issue type="bug">
        Fix querystring polyfill error [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/249">
          #249
        </a>
        ]{" "}
      </Issue>
    </Release>
    <Release
      version="2.15"
      date="May 10th, 2023"
      heading="Langur Henry"
      showVersion={showVersion}
    >
      <Issue type="improvement">
        {" "}
        Add Device Magic Web Form Users to the list of recall destinations [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/875">
          #875
        </a>,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-api/issues/773">
          #773
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/217">
          #217
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add API functionality to adjusting Solo times [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/874">#874</a>]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add processing support for SBE25 CTDs [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/844">
          #844
        </a>,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-api/issues/812">
          #812
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/210">
          #210
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/205">
          #205
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add filters to the Solo confirm page [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/820">
          #820
        </a>,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-database/pull/382">
          #382
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add search/filter functionality to solo confirm page [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/180">
          #180
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Switch Hakai API documentation to use MkDocs
        http://hakaiinstitute.github.io/hakai-api/ [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/776">#776</a>]
      </Issue>
      <Issue type="improvement">
        {" "}
        Improve CTD QC workflow by adding processing stage and ctd cast pk
        columns to the ctd qc view [
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/376">
          #376
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-database/pull/381">
          #381
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Provide a clearer &#39;limited access&#39; warning to users who log into
        the portal with non-hakai email accounts [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/176">
          #176
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/213">
          #213
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Allow building the Hakai Data Portal as a docker image to lower
        development overhead and improve deployment portability [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/208">
          #208
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add links to the OSV, matrix viewer, and historical matrix viewer to the
        portal [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/200">
          #200
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/222">
          #222
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Allow users to hide the search fields on the status page by clicking the
        search heading [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/187">
          #187
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add a column to the CTD annotation page to indicate if a cast is
        &#39;static&#39; or &#39;dynamic&#39; [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/177">
          #177
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Fix cast type display on CTD annotation page [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/212">
          #212
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Improve authentication flow in the Hakai API and Portal [
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/824">
          #824
        </a>,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-api/pull/823">#823</a>]
      </Issue>
      <Issue type="improvement">
        {" "}
        Add Vessel column to YSI and Staff Guage output views [
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/379">
          #379
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-database/pull/380">
          #380
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        Always display depth and pressure values in CTD Research Ready output
        from the portal. Previously these values were removed if unflagged. [
        <a href="https://github.com/HakaiInstitute/hakai-database/pull/375">
          #375
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        Corrected an error during the annotation of CTD or Solo files. If no
        casts were detected the portal would display a blank page. [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/211">
          #211
        </a>
        ,{" "}
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/218">
          #218
        </a>
        ]
      </Issue>
    </Release>
    <Release
      version="2.14"
      date="Feb 8st 2023"
      heading="Shearling Mole"
      showVersion={showVersion}
    >
      <Issue type="improvement"> Move issue tracking from Jira to GitHub</Issue>
      <Issue type="improvement">
        {" "}
        Process eDNA samples from Biomarathon Forms [
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/358">
          #358
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Update EIMS portal login flow to use new auth system [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/178">
          #178
        </a>
        ]
      </Issue>
      <Issue type="improvement">
        {" "}
        Allow downloading of post QC (research ready) CTD Data from the portal [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/168">
          #168
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        fix filter type in Chlorophyll dataset [
        <a href="https://github.com/HakaiInstitute/hakai-database/issues/364">
          #364
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        fix solo upload error [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/190">
          #190
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        fix ctd upload error [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/191">
          #191
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        fix portal redirect url when selecting organization and workarea [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/pull/171">
          #171
        </a>
        ]
      </Issue>
      <Issue type="bug">
        {" "}
        fix blank page error when selecting organization and workarea [
        <a href="https://github.com/HakaiInstitute/hakai-data-portal-v2/issues/170">
          #170
        </a>
        ]
      </Issue>
    </Release>
    <Release
      version="2.13"
      date="Dec 1st 2022"
      heading="Siamang Yardland"
      showVersion={showVersion}
    >
      <Issue
        type="improvement"
        title="Allow manual override of ctd drop times"
        key="EIMS-1461"
        status="Done"
      >
        {" "}
        Allow the manual adjustment of detected ctd instrument start, bottom,
        and end times. To do this open a chart view of a cast and adjust sliders
        to bracket a cast. For dynamic CTD casts this allows the setting of
        start and bottom times. For CTD drops linked to static casts the start,
        bottom, and end cast times are detected and set.
      </Issue>
      <Issue
        type="improvement"
        title="Add map option to ctd anotation page to show ctd collection locations (start, bottom, end)"
        key="EIMS-1458"
        status="Done"
      >
        {" "}
        During the ctd annotation process, users can now view ctd casts in
        relation to existing known sampling sites by clicking the map button on
        the ctd annotation page.
      </Issue>
      <Issue
        type="bug"
        title="uploading multiple solo files causes api to return 500 errors for some files"
        key="EIMS-1453"
        status="Done"
      >
        {" "}
        Uploading multiple solo files at a time no longer causes an error
      </Issue>
      <Issue
        type="bug"
        title="Warning - no flowmeter used on biomarathon/siege forms"
        key="EIMS-1449"
        status="Done"
      >
        {" "}
        Reduce false errors by adding a checkbox to Bio Marathon forms to
        indicate when no flow meters are used.
      </Issue>
      <Issue
        type="bug"
        title="Can't submit Zooplankton Isotope forms"
        key="EIMS-1447"
        status="Done"
      >
        {" "}
        Improved how organizations are handled in the portal. When uploading
        excel forms a change to an organization will generate a warning rather
        than an error. Note that if data is changed to an organization to which
        the user does not have access they will lose the ability to change this
        data in the future. Do not ignore the warnings.
      </Issue>
      <Issue
        type="improvement"
        title="Add integration tests on PR using CircleCI"
        key="EIMS-1441"
        status="Done"
      >
        {" "}
        Improved development workflow by adding integration testing during pull
        request creation and updating.
      </Issue>
      <Issue
        type="improvement"
        title="Timezone querying support and documentation"
        key="EIMS-1440"
        status="Done"
      >
        {" "}
        Users can now download data via the api or portal in any standard
        timezone. Previously, UTC or PDT/PST timezones were hard-coded into the
        api and portal respectively. Timezone can be set in the advanced options
        of the Data Tools Download page.
      </Issue>
      <Issue
        type="improvement"
        title="Run ctd tests on pull request"
        key="EIMS-1436"
        status="Done"
      >
        {" "}
        improve testing during development workflow
      </Issue>
      <Issue
        type="bug"
        title="Skeena casts aren't being processed"
        key="EIMS-1433"
        status="Done"
      >
        {" "}
        fix processing of ctd casts form the skeena workarea
      </Issue>
      <Issue
        type="bug"
        title="Duplicates in Chlorophyll View"
        key="EIMS-1431"
        status="Done"
      >
        {" "}
        Resolved duplicate chlorophyll samples appearing in downloaded datasets
        which were the result of multiple annotations of the same solo cast or
        duplicated chlorophyll result uploads
      </Issue>
      <Issue
        type="improvement"
        title="Post-QC ctd view"
        key="EIMS-1429"
        status="Done"
      >
        {" "}
        Added a post QC view of ctd data. This will allow the publishing of
        research-ready ctd data through automated systems such as ERDDAP.
      </Issue>
      <Issue
        type="improvement"
        title="Add flowmeter calibrations to zooplankton tows"
        key="EIMS-1423"
        status="Done"
      >
        {" "}
        Added flowmeter calibration information to zooplankton tow output to
        better support validation of zooplankton results.
      </Issue>
      <Issue
        type="new feature"
        title="Make API endpoints for QARTOD flags"
        key="EIMS-1422"
        status="Done"
      >
        {" "}
        Enable uploading of QARTOD flags to ctd data via the api
      </Issue>
      <Issue
        type="bug"
        title="Historical Matrix is using deprecated tabletop.js modual"
        key="EIMS-1421"
        status="Done"
      >
        {" "}
        Replaced deprecated on libraries with maintained ones in the OSV
      </Issue>
      <Issue
        type="bug"
        title="Invertebrate Data is Duplicated After Resubmitting Through Excel (Same fix as Fish table)"
        key="EIMS-1420"
        status="Done"
      >
        {" "}
        Redesign how invertibraite data is stored in our database to eliminate
        duplicate entries
      </Issue>
      <Issue
        type="bug"
        title="Annotate multiple form to one RBR RSK file "
        key="EIMS-1417"
        status="Done"
      >
        {" "}
        Users can now annotate casts from a single RBR ctd file with entries
        from multiple device magic forms. Previously it was assumed that only
        one form was used to annotate a file of ctd casts.
      </Issue>
      <Issue
        type="improvement"
        title="file_path for submissions in eims.forms not valid with docker"
        key="EIMS-1403"
        status="Done"
      >
        {" "}
        fixed incorrect file path for uploaded excel files. All excel files
        related to discrete samples should now be downloadable from the portal
        after submitting them
      </Issue>
      <Issue
        type="improvement"
        title="Add excel-downloader to docker-compose setup"
        key="EIMS-1399"
        status="Done"
      >
        {" "}
        Moved excel downloader to docker containers along with the rest of the
        hakai portal ecosystem
      </Issue>
      <Issue
        type="improvement"
        title="Add Combined option to Sample Status field"
        key="EIMS-1392"
        status="Done"
      >
        {" "}
        Added a ‘combined’ option to the sample status field for all sample
        types. If one or more samples are combined together this can now be
        indicated by setting the sample status. A note should be added to the
        source and destination sample indicating which samples have been
        combined to make the new sample.
      </Issue>
      <Issue
        type="task"
        title="Dockerize tide prediction tool"
        key="EIMS-1386"
        status="Done"
      >
        {" "}
        Moved the tide prediction tool to a docker container.
      </Issue>
      <Issue
        type="new feature"
        title="Add Feature Request button on portal"
        key="EIMS-1379"
        status="Done"
      >
        {" "}
        Users can now request new features/changes to the portal by clicking the
        ‘Request a feature’ button on the left application sidebar.
      </Issue>
      <Issue
        type="bug"
        title="WSC Organization gets changed to Hakai Organization"
        key="EIMS-1377"
        status="Done"
      >
        {" "}
        Water Survey of Canada is now treated as its own organization within the
        portal rather than auto-changing it to hakai. This allows for
        finer-grain access control to our data.
      </Issue>
      <Issue
        type="improvement"
        title="Firmware version NA"
        key="EIMS-1372"
        status="Done"
      >
        {" "}
        fix version as NA bug in RBR .txt files
      </Issue>
      <Issue
        type="bug"
        title="Can’t set filter-type to null in Nutrient dataset"
        key="EIMS-1370"
        status="Done"
      >
        {" "}
        Users can now clear the filter type field when uploading excel forms if
        the ‘filtered’ field is set to false. This allows fixing some historical
        errors due to auto-populated filter type fields
      </Issue>
    </Release>
    <Release
      version="2.12"
      date="Mar 8th 2022"
      heading="Grebe Minim"
      showVersion={showVersion}
    >
      <Issue
        type="task"
        title="Update CTD geofence to include the Skeena watershed"
        key="EIMS-1413"
        status="Done"
      >
        {" "}
        Updates CTD geofence to include all Skeena watershed sites.
      </Issue>
      <Issue
        type="new feature"
        title="Allow selection of bottom date time in solo annotations"
        key="EIMS-1412"
        status="Done"
      >
        {" "}
        Users can now select datetime bounds for a casts bottom depth in the
        dialog that displays the cast’s profile
      </Issue>
      <Issue
        type="bug"
        title="Persistent Error with sqlite/rsktools"
        key="EIMS-1411"
        status="Done"
      >
        {" "}
        fix: <code>rsk-converter</code> service was dropping last packet when
        uploading <code>rsk</code> files.
      </Issue>
      <Issue
        type="bug"
        title="Fish samples are duplicated after resubmitting with excel"
        key="EIMS-1407"
        status="Done"
      >
        {" "}
        Fixes an issue where fish samples were being duplicated when samples
        were downloaded from excel and re-uploaded.
      </Issue>
      <Issue
        type="improvement"
        title="Processing Flag"
        key="EIMS-1404"
        status="Done"
      >
        {" "}
        Add flags for any cast-level processing errors{" "}
      </Issue>
      <Issue
        type="bug"
        title="Downloaded data appears in UTC instead of PDT/PST"
        key="EIMS-1390"
        status="Done"
      >
        {" "}
        Fixes an issue where data downloaded from the portal was appearing in
        UTC time instead of PDT/PST time.{" "}
      </Issue>
      <Issue
        type="new feature"
        title="Location Qartod flag"
        key="EIMS-1389"
        status="Done"
      >
        {" "}
        QARTOD flags added to alert when there are large discrepancies in
        site-station distance
        [https://ioos.noaa.gov/project/qartod/|https://ioos.noaa.gov/project/qartod/|smart-link]{" "}
      </Issue>
      <Issue
        type="improvement"
        title="Change row_flag column to Sample status and restrict column values to  “collected”, “submitted”, “not available” and “results”"
        key="EIMS-1384"
        status="Done"
      >
        No release note- confirm deleting this issue from notes
      </Issue>
      <Issue
        type="improvement"
        title="Add 'Software Version' to ctd cast views"
        key="EIMS-1383"
        status="Done"
      >
        {" "}
        As we update version we would then be able to reprocess casts based on
        which version of the software was previously used
      </Issue>
      <Issue
        type="improvement"
        title="Clean up console errors on hakai-data-portal"
        key="EIMS-1376"
        status="Done"
      ></Issue>
      <Issue
        type="bug"
        title="Unexpected distances between site and station"
        key="EIMS-1375"
        status="Done"
      >
        {" "}
        Switch to postgis <code>geography</code> type
      </Issue>
      <Issue
        type="improvement"
        title="Update .rsk processing for solo instruments"
        key="EIMS-1373"
        status="Done"
      >
        {" "}
        Portal/api now accepts solo <code>.rsk</code> files, using{" "}
        <code>rsk- converter</code> service to convert them to{" "}
        <code>*_eng.txt</code> files.{" "}
      </Issue>
      <Issue
        type="bug"
        title="Marking casts as miscasts when there is no associated form causes error"
        key="EIMS-1365"
        status="Done"
      >
        {" "}
        We now differentiate between miscasts due to accidents that occur during
        a cast, and toggle miscasts due to the instrument being switched on and
        off when above water.{" "}
      </Issue>
      <Issue
        type="sub-task"
        title="Replace zabbix CTD monitoring trigger/action with simple cronjob"
        key="EIMS-1364"
        status="Done"
      >
        {" "}
        Easier to maintain and resolve the sentry errors on rebuild.
      </Issue>
      <Issue
        type="improvement"
        title="Add process log to CTD excel download"
        key="EIMS-1302"
        status="Done"
      ></Issue>
      <Issue
        type="improvement"
        title="Remove use of excel files from RBR processing script"
        key="EIMS-1217"
        status="Done"
      >
        {" "}
        Matlab script now fetches cast data directly from the api, and runs on a
        cronjob using <code>flock</code> to prevent overlapping processing from
        running
      </Issue>
      <Issue
        type="improvement"
        title="Add action column to nearshore views"
        key="EIMS-1034"
        status="Done"
      >
        {" "}
        Samples can now be deleted for all Nearshore views through the xlsx
        action column.
      </Issue>
    </Release>
    <Release
      version="v2.11"
      date="Oct 20th 2021"
      heading="Uraster Tesla"
      showVersion={showVersion}
    >
      <Issue
        type="bug"
        title="Too many work areas breaks UI"
        key="EIMS-1374"
        status="done"
      >
        {" "}
        Fixes issue where having access to a large number of work areas broke
        the UI.
      </Issue>
      <Issue
        type="bug"
        title="Invert size_cm does not update from excel"
        key="EIMS-1354"
        status="Done"
      >
        {" "}
        Fixes an issue where size_cm in the invertebrates table was not being
        updated from excel files.{" "}
      </Issue>
      <Issue
        type="new feature"
        title="Total and dissolved AKAN CAT pH"
        key="EIMS-1349"
        status="Done"
      >
        {" "}
        Total and dissolved columns have been added to all AKAN CAT PH samples.
      </Issue>
      <Issue
        type="bug"
        title="Uploading excel files with multiple data tabs broken"
        key="EIMS-1348"
        status="Done"
      >
        {" "}
        Fixes issue where uploading excel files with multiple tabs would hang
        with no response.
      </Issue>
      <Issue
        type="improvement"
        title="Update CTD Download page filters"
        key="EIMS-1341"
        status="Done"
      >
        {" "}
        Updates list of CTD devices and serial numbers.
      </Issue>
      <Issue
        type="improvement"
        title="Make error filter options dynamic"
        key="EIMS-1327"
        status="Done"
      >
        {" "}
        The Data Tools download page now shows all error and warning hints
        present in the database.
      </Issue>
      <Issue
        type="improvement"
        title="Make change form order more intuitive"
        key="EIMS-1326"
        status="Done"
      >
        {" "}
        Arrows and highlighting have been added to the change form order feature
        on the submission status page to make it more intuitive.{" "}
      </Issue>
      <Issue
        type="improvement"
        title="Add QARTOD flag columns to ctd data"
        key="EIMS-1295"
        status="Done"
      >
        {" "}
        QARTOD flags have been added to CTD data
      </Issue>
      <Issue
        type="improvement"
        title="Review static cast detection script"
        key="EIMS-1288"
        status="Done"
      >
        {" "}
        RBR files with static (aka shallow) casts are segmented into separate
        casts using depth instead of conductivity. Depth is more reliable than
        conductivity because static casts are typically taken in freshwater.
        Both normal casts and static casts are still initially segmented based
        on time, so that if an instrument is turned off and later turned on a
        again, the gap in the recorded timestamps would start new cast.
      </Issue>
      <Issue
        type="new feature"
        title="Searching by project"
        key="EIMS-599"
        status="Done"
      >
        {" "}
        Allow users to search for data by project - IE Freshwater, oceanography,
        Nearshore.
      </Issue>
    </Release>
    <Release
      version="v2.10"
      date="Jul 9th 2021"
      heading="Loris Pottle"
      showVersion={showVersion}
    >
      <Issue
        type="improvement"
        title="Add pH to CTD raw data download"
        key="EIMS-1351"
        status="Done"
      >
        {" "}
        Fixed issue where Nature Trust CTD data was not being output to Excel or
        CSV files due to missing pH columns. PH data is now included in CTD
        output files.
      </Issue>
      <Issue
        type="bug"
        title="Sensor network routes broken"
        key="EIMS-1346"
        status="Done"
      >
        Fixes a bug that was affecting sensor network routes.
      </Issue>
      <Issue
        type="improvement"
        title="Add popup warning if users login with personal email account"
        key="EIMS-1342"
        status="Done"
      >
        {" "}
        Users are now greeted with a warning modal letting them know features
        will be restricted when logging into the portal with any email that does
        not end in @hakai.org.{" "}
      </Issue>
      <Issue
        type="improvement"
        title="Upgrade Portal to MUI 4"
        key="EIMS-1338"
        status="Done"
      >
        Site-wide front end updates and improvements.
      </Issue>
      <Issue
        type="feature"
        title="Add dilution factor to chlorophyll data"
        key="EIMS-1337"
        status="Done"
      >
        {" "}
        Adds dilution factor column. All samples with no dilution factor value
        will be given a default value of 1.{" "}
      </Issue>
      <Issue
        type="improvement"
        title="Add sites view and endpoint"
        key="EIMS-1334"
        status="Done"
      >
        Users can now access a list of samplings sites and their coordinates
        using the API endpoint `/eims/output_sites`.
      </Issue>
      <Issue
        type="feature"
        title="Portal down for maintenance during rebuilds"
        key="EIMS-1287"
        status="Done"
      >
        {" "}
        The portal now automatically displays a more user-friendly &#39;down for
        maintenance&#39; page when rebuilds are running.
      </Issue>
    </Release>
    <Release
      version="v2.9"
      date="Apr 22nd 2021"
      heading="Monkey Puzzle"
      showVersion={showVersion}
    >
      <Issue
        type="improvement"
        title="Restrict CTD annotation possible form matches"
        key="EIMS-1328"
        status="Done"
      >
        The CTD annotation tool now takes serial number into account when
        suggesting form matches.
      </Issue>
      <Issue
        type="feature"
        title="New features in Hakai API querying"
        key=""
        status="Done"
      >
        Improvements include using brackets for subqueries and advanced date
        querying syntax.
      </Issue>
      <Issue
        type="improvement"
        title="OSV CORS error"
        key="EIMS-1311"
        status="Done"
      >
        {" "}
        Fixed issue crashing OSV by changing elab data requests to go through
        the Hakai API.
      </Issue>
      <Issue
        type="bug"
        title="Incorrect phytoplankton Sample ID field expression"
        key="EIMS-1305"
        status="Done"
      >
        {" "}
        Correct autogenerated phytoplankton id in Biomarathon forms.
      </Issue>
      <Issue
        type="bug"
        title="2016 fish species showing up as 'NA' when they should be populated"
        key="EIMS-1304"
        status="Done"
      >
        {" "}
        Fixed bug where fish &#39;species&#39; were not being retrieved from
        older 2016 format of Nearshore forms.
      </Issue>
      <Issue
        type="bug"
        title="Change sampling events to display local CTD/Solo times"
        key="EIMS-1303"
        status="Done"
      >
        {" "}
        CTD and Solo times are now displayed in the same format as other sample
        types.
      </Issue>
      <Issue
        type="bug"
        title="2016 invertebrate species showing up as 'NA' when they should be populated"
        key="EIMS-1297"
        status="Done"
      >
        {" "}
        Fixed bug where invertebrate &#39;species&#39; were not being retrieved
        from older 2016 format of Nearshore forms.
      </Issue>
      <Issue
        type="bug"
        title="Fix CTD update function"
        key="EIMS-1292"
        status="Done"
      >
        {" "}
        Now allows bottom location to be updated for CTD forms.
      </Issue>
      <Issue
        type="task"
        title="Add NTBC station locations"
        key="EIMS-1291"
        status="Done"
      >
        {" "}
        Add Nature Trust station coordinates to database.
      </Issue>
      <Issue
        type="bug"
        title="Report all errors from ctd uploads, not just the first one"
        key="EIMS-1270"
        status="Done"
      >
        {" "}
        Display all CTD errors on the portal when uploading multiple files with
        issues.
      </Issue>
      <Issue
        type="task"
        title="Changes to RBR data processing"
        key="EIMS-1240"
        status="Done"
      >
        {" "}
        Fixed temperature correction on Rinko DO sensors and upgrade Matlab to
        R2020a.
      </Issue>
      <Issue
        type="bug"
        title="OSV: Fix Elab metadata order bugs"
        key="EIMS-1233"
        status="Done"
      >
        {" "}
        Edit OSV Elab tests so that the sample metadata order doesn&#39;t
        matter. This mostly affected HPLC data but applies to all sample types.
      </Issue>
      <Issue
        type="improvement"
        title=" Add functionality to delete ctd drops"
        key="EIMS-1226"
        status="Done"
      >
        {" "}
        Can now delete ctd drops using the same method as other sample types, by
        adding a &#39;D&#39; to the &#39;Action&#39; column of the portal excel
        output and reuploading.
      </Issue>
      <Issue
        type="bug"
        title="Zooplankton tow config "
        key="EIMS-1159"
        status="Done"
      >
        {" "}
        Fixed bug that assigned tow configuration to &#39;Bongo&#39; when excel
        field was blank, even if the tow config had previously been assigned
        &#39;Single&#39;
      </Issue>
    </Release>
    <Release
      version="v2.8"
      date="Nov 5th 2020"
      heading="Goosebumps & Goose bugs"
      showVersion={showVersion}
    >
      <Issue
        type="feature"
        title="Workarea and Organization filtering"
        status="Done"
      >
        The Portal now better supports data collaborations with groups outside
        of Hakai. Users have been added to google groups with the organizations
        they are involved in, and this information is embedded in the API&#39;s
        querying and filtering. You can review your orgs and workareas on the
        new &#39;Home&#39; page.
      </Issue>
      <Issue type="feature" title="Nature Trust CTD Data" status="Done">
        The Portal now accomodates Nature Trust CTD data. Changes include a
        template for converting metadata to our standardized Device Magic
        generated format, adding NT-specific metadata and data fields to the
        database, static cast detection, storage, and flagging, updated text
        file parsing and filename validation, and a new workarea.
      </Issue>
      <Issue
        type="improvement"
        title="Add UWT data and Clayoquot workarea"
        key="EIMS-1268"
        status="Done"
      >
        Accomodate CTD data from new collaboration with UWT.
      </Issue>
      <Issue
        type="bug"
        title="Plankton microscopy IDs should be case insensitive"
        key="EIMS-1269"
        status="Done"
      >
        Plankton microscopy IDs are now uppercase like all other Hakai IDs.
      </Issue>
      <Issue
        type="bug"
        title="Throw error if form is submitted without date"
        key="EIMS-1258"
        status="Done"
      >
        Missing date is now a form-blocking error.
      </Issue>

      <Issue
        type="improvement"
        title="Change biomarathon survey name"
        key="EIMS-1253"
        status="Done"
      >
        Biomarathon surveys renamed to bioweekly and biotidal.
      </Issue>

      <Issue
        type="bug"
        title="Weather fields from DM and excel CTD forms not being uploaded"
        key="EIMS-1245"
        status="Done"
      >
        {" "}
        The “Wind”, “Swell”, and “Sky Cover” fields will now upload correctly
        from CTD drop excel files and device magic forms.
      </Issue>

      <Issue
        type="new feature"
        title="Process Partial Biomarathon Forms"
        key="EIMS-1241"
        status="Done"
      >
        The sample types we already support in Marine/Zoop forms are now also
        processed from Biomarathon forms.
      </Issue>

      <Issue
        type="bug"
        title="Submission Status 'Row Discarded'"
        key="EIMS-737"
        status="Done"
      >
        Fixed a bug that when viewing the details of a submission error with
        “Row Discarded” it would show that changes had been made to the
        database. Since no changes are saved to the database when this error
        occurs the message has been changed to only show the discarded row.
      </Issue>
      <Issue
        type="bug"
        title="Inform users when ctd file didn't upload due to hakai id conflict"
        key="EIMS-1271"
        status="Done"
      >
        Added a unique error for when a CTD file fails to upload due to the cast
        already having been uploaded in a different file.
      </Issue>
    </Release>
    <Release
      version="v2.6-2.7"
      date="Jun 23rd 2020"
      heading="Return of the Release"
      showVersion={showVersion}
    >
      <Issue
        type="bug"
        title="Solo metadata excel uploads failing"
        key="EIMS-1146"
        status="Done"
      >
        Added solo raw headers to upload validator.
      </Issue>
      <Issue
        type="bug"
        title="Throw warning when CSV files uploaded to portal"
        key="EIMS-1145"
        status="Done"
      >
        Added warning message when CSV files are uploaded to Excel dropzone,
        instead of failing silently.
      </Issue>
      <Issue
        type="bug"
        title="Solo drop metadata not matching cast"
        key="EIMS-1144"
        status="Done"
      >
        Fixed bug where UTC time was being compared to PST time.
      </Issue>
      <Issue
        type="improvement"
        title="Run Seabird processing more frequently"
        key="EIMS-1142"
        status="Done"
      >
        Seabird processing now runs near-real time like RBR processing, instead
        of nightly.
      </Issue>
      <Issue
        type="task"
        title="Add new xmlcon files to correct issues with seabird auxilary sensors"
        key="EIMS-1140"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Add nearshore sites to database"
        key="EIMS-1139"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Need a new way to determine uniqueness of ctd files based on file type"
        key="EIMS-1130"
        status="Done"
      >
        Fixed bug so that status box on CTD upload page differentiates between
        files with the same name but different extensions. Removed functionality
        that fetched previously uploaded files and add them to the status box if
        they weren&#39;t annotated yet.
      </Issue>
      <Issue
        type="task"
        title="Add zabbix monitoring to CTD processing"
        key="EIMS-1108"
        status="Done"
      >
        Zabbix alerts sends warning if CTD processing is stalled.
      </Issue>
      <Issue
        type="improvement"
        title="Add chla flag columns to HPLC data"
        key="EIMS-1046"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Add functionality to delete ysi calibrations"
        key="EIMS-1225"
        status="Done"
      >
        YSI calibrations can now be deleted when an excel file with D in the
        action column is uploaded.
      </Issue>
      <Issue
        type="improvement"
        title="Add Hakai ID to CTD download output"
        key="EIMS-1222"
        status="Done"
      >
        Hakai ID is now included in the spreadsheets downloaded from the CTD
        Tools page.
      </Issue>
      <Issue
        type="bug"
        title="CTD pdf download triggers the CTD data downloading icon"
        key="EIMS-1216"
        status="Done"
      >
        The CTD processing pdf download and CTD data download now have separate
        downloading actions and icons.
      </Issue>
      <Issue
        type="improvement"
        title="Add primer fields for microbial samples"
        key="EIMS-1213"
        status="Done"
      >
        Can now indicate for microbial samples if a sample has been sequenced
        with various primers. Descriptions of these primers can be seen on the
        Hakai Variable tab of downloaded microbial excel forms.
      </Issue>
      <Issue
        type="improvement"
        title="Add replicate and metadata QC fields for nutrient samples"
        key="EIMS-1212"
        status="Done"
      >
        Can now indicate if a nutrient sample is part of a series of replicates
        and the quality of the sample metadata.
      </Issue>
      <Issue
        type="improvement"
        title="Add TOBA to project/survey links"
        key="EIMS-1211"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Add RBRconcerto3 to instrument filters on download page"
        key="EIMS-1210"
        status="Done"
      />
      <Issue
        type="bug"
        title="OSV: HPLC Elab test"
        key="EIMS-1208"
        status="Done"
      >
        Fix order of HPLC elab test to correct false negative result.
      </Issue>
      <Issue
        type="bug"
        title="Correct missing nutrient data"
        key="EIMS-1207"
        status="Done"
      >
        Update DM forms to accept 4 replicates instead of 3.
      </Issue>
      <Issue
        type="improvement"
        title="Add net ID to zooplanktoon biomass view"
        key="EIMS-1204"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Add flag column 'c_flag' to c13 results"
        key="EIMS-1203"
        status="Done"
      />
      <Issue
        type="bug"
        title="OSV crashes when elab doesn't return results"
        key="EIMS-1201"
        status="Done"
      >
        Fix bug where elab not finding any samples for requested parameters
        fails the tests instead of crashing.
      </Issue>
      <Issue
        type="bug"
        title="OSV not testing for bongo as a sample type"
        key="EIMS-1199"
        status="Done"
      >
        Reorganized zooplankton variable types and corrected bug.
      </Issue>
      <Issue
        type="bug"
        title="OSV zooplankton net IDs not matching"
        key="EIMS-1198"
        status="Done"
      >
        Correct zooplankton net IDs.
      </Issue>
      <Issue
        type="bug"
        title="Solo collected time not populating from zooplankton forms"
        key="EIMS-1197"
        status="Done"
      >
        Fix bug so that solo collected times are retreived from zooplankton
        forms.
      </Issue>
      <Issue
        type="bug"
        title="OSV zooplankton event level tests failing when they shouldn't"
        key="EIMS-1196"
        status="Done"
      >
        Remove test that compares event depth instead of bottom depth (which
        could be variable anyway). Match on sample type name instead.
      </Issue>
      <Issue
        type="bug"
        title="OSV tests are case sensitive when they shouldn't be"
        key="EIMS-1195"
        status="Done"
      >
        Update tests so that (for example) &#34;TRUE&#34; matches &#34;True&#34;
        and &#34;true&#34;
      </Issue>
      <Issue
        type="improvement"
        title="Add rebuild date to portal"
        key="EIMS-1194"
        status="Done"
      >
        Users can check Data Tools Download page for the last time the database
        was rebuilt.
      </Issue>
      <Issue
        type="bug"
        title="Dynamically calculate chla and phaeo chlorophyll values"
        key="EIMS-1188"
        status="Done"
      >
        Values are calculated on the fly now, so that updating calibration
        sheets also updates the results.
      </Issue>
      <Issue
        type="bug"
        title="Watershed sites linked to wrong workarea"
        key="EIMS-1179"
        status="Done"
      />
      <Issue
        type="improvement"
        title="Update watershed site id for LAKEC surveys"
        key="EIMS-1168"
        status="Done"
      >
        Standardize watershed-lake-sitetype format for setting ID.
      </Issue>
      <Issue
        type="bug"
        title="Fix CTD cast download date display"
        key="EIMS-1166"
        status="Done"
      >
        Fix bug where date, but not time, was being displayed in UTC.
      </Issue>
    </Release>

    <Release
      version="v2.5"
      date="July 17 2019"
      heading="Bongo Zolotnik"
      showVersion={showVersion}
    >
      <Issue
        type="bug"
        title="TS Results tss_mg_l has negative values"
        key="EIMS-1120"
        status="Done"
      >
        {" "}
        In Total Solids sample type, fixed calculated field tss_mg_l which was
        displaying negative values
      </Issue>
      <Issue
        type="new feature"
        title="Add Gwaii Haanas workarea"
        key="EIMS-1115"
        status="Done"
      >
        {" "}
        Gwaii Haanas work area was added to the portal, database, and device
        magic forms in order to support the new Parks Canada CTD program.
      </Issue>
      <Issue
        type="improvement"
        title="Add new solo serials and device models"
        key="EIMS-1109"
        status="Done"
      >
        {" "}
        New solo serial numbers have been added to database and portal, and
        parse script updated to convert RBRSolo³ to RBRSolo3.
      </Issue>
      <Issue
        type="bug"
        title="Fix annotation page refresh logic"
        key="EIMS-1105"
        status="Done"
      >
        {" "}
        Fixed bug where reuploading a file wouldn&#39;t refresh the annotation
        page. Previously users would reupload a file, go back to the annotation
        page, select the file, and the portal would request the old pk,
        resulting in an &#39;undefined binding&#39; error.
      </Issue>
      <Issue
        type="bug"
        title="Portal e.datatools.getIn(...) is undefined"
        key="EIMS-1078"
        status="Done"
      >
        {" "}
        Fixed a bug where changing levels in the Submission Status page form
        data viewer caused a blank screen
      </Issue>
      <Issue
        type="bug"
        title="Add hakai_id to CTD download page filters"
        key="EIMS-1073"
        status="Done"
      >
        {" "}
        CTD casts can now be filtered by hakai_id.
      </Issue>
      <Issue
        type="bug"
        title="nearshore flowering_shoots not mapping"
        key="EIMS-1066"
        status="Done"
      >
        {" "}
        Added flowering_shoots field to Seagrass Density dataset
      </Issue>
      <Issue
        type="new feature"
        title="Add CTD annotation review/confirm page"
        key="EIMS-1050"
        status="Done"
      >
        {" "}
        Added CTD and Solo “Annotation Review” features to the Data
        Tools/Download page. These features show who uploaded/annotated a file a
        when, and should make it much easier to tell if a file was annotated
        properly or not. Use the &#39;advanced search&#39; to filter by
        “is_annotated”, “uploaded_by”, etc. The Solo Confirm page (under Solo
        Tools) will eventually be retired.
      </Issue>
      <Issue
        type="new feature"
        title="CTD QC Tool"
        key="EIMS-1029"
        status="Done"
      >
        {" "}
        Flags can be added to CTD data on a per cast / per data type basis using
        the new CTD QC Tool found under “Data Tools”.
      </Issue>
      <Issue
        type="bug"
        title="Some Seagrass Field forms not processed by DB"
        key="EIMS-1025"
        status="Done"
      >
        {" "}
        Fixed some Seagrass Field forms from 2016 that weren&#39;t being
        processed
      </Issue>
      <Issue
        type="sub-task"
        title="Release new RBR processing version"
        key="EIMS-952"
        status="Done"
      >
        {" "}
        Version 1.1 of the RBR processing script has been released and all RBR
        CTD data reprocessed with the updated code. Of note to users is the
        updated pdf processing report.
      </Issue>

      <Issue
        type="improvement"
        title="CTD Cast Distribution Visualization"
        key="EIMS-688"
        status="Done"
      >
        {" "}
        Added new data visualization showing the distribution of casts in the
        CTD data download page search results. Previously the query would just
        return the number of casts in the search. Now users can quickly see how
        sampling has varied over time and the depths those casts were taken at.
        The brush can be used to zoom in on a sub-selection. Please note this
        feature can be slow with huge searches and works optimally for a small
        number of sites over large time periods.
      </Issue>
    </Release>
    <Release
      version="v2.4"
      date="Feb 25th 2019"
      heading="Zokor Coulomb"
      showVersion={showVersion}
    >
      <Issue
        type="bug"
        title="Some o18 samples missing from FGS combined outputs"
      >
        Fixed linking issue in FGS Combined and FGS Combined with POMS output
        views. Previously samples collected in events not containing nutrients
        were not reported.{" "}
      </Issue>
      <Issue type="bug" title="'Select All' option in drop-downs">
        When you are using a drop down list to select an item, you can pick
        Select All to pick all of the items that start with your search
        criteria. EG, type Outlet in Site ID and then click Select All to select
        all the outlet sites.
      </Issue>
      <Issue type="bug" title="Download page pasted list issues">
        Improved pasting of items from CSV/Excel into drop downs
      </Issue>
      <Issue type="sub-task" title="CTD QC Excel Download">
        {" "}
        Excel output for QCing CTD data can now be accessed from the Data Tools
        → Download page and can start being used. Feature to upload in progress.
      </Issue>
      <Issue
        type="new feature"
        title="Add organization as a field and allow partitioning data by organization"
      >
        Some notes from implementation: * currently project is inferred from
        survey, but if you create a new organization this creates a new
        site/survey/workarea linked to this organization so project can&#39;t be
        inferred anymore. right now any new organizations will have a project of
        &#39;none&#39; * didn&#39;t update ysi calibrations or marinegeo
        seagrass lab (not currently linked to workarea) * JSP sites are
        hardcoded (can&#39;t update) so just hardcoded default organization to
        Hakai Added support for &#39;Organization&#39; other than Hakai. Field
        added to marine, freshwater, marinegeo, ctd forms, but will default to
        Hakai if not updated.
      </Issue>
      <Issue type="bug" title="A few POMS samples not in output view">
        Fixed an issue where a few POMS samples werent being displayed on the
        portal.
      </Issue>
      <Issue
        type="improvement"
        title="Download page Sample Type menu now searchable"
      >
        Now you can quickly find your sample type by typing in the first few
        letters.
      </Issue>
      <Issue type="bug" title="Add link to ctd.ctd_cast from eims.ctd_drop">
        Improved link between ctd cast data and ctd metadata captured through
        device magic forms. Changes to ctd drop metadata will no longer brake
        the link to ctd casts.{" "}
      </Issue>
      <Issue type="bug" title="process error in zooplankton biomass upload">
        Remove process as a required field in zooplankton biomass samples which
        fixes a bug during zooplankton biomass processing.{" "}
      </Issue>
      <Issue type="improvement" title="Remove row numbers in output views">
        Row numbers have been removed from the download preview and API. Let us
        know if you miss them.
      </Issue>
      <Issue type="bug" title="YSI data issue">
        There was an issue with updating YSI data that has been resolved.
      </Issue>
      <Issue
        type="bug"
        title="Error log for blocked forms is lost during a rebuild"
      >
        During a database rebuild the error log for blocked forms is now
        correctly populated.{" "}
      </Issue>
      <Issue
        type="task"
        title="Invalid secchi depth when uploading ctd_drop file."
      >
        fixed null secchi depth bug when uploading ctd drop files.{" "}
      </Issue>
      <Issue type="bug" title="Don't use DM devices that are Pending Approval">
        There was an issue with not being able to recall to certain DeviceMagic
        devices that has been fixed.
      </Issue>
      <Issue
        type="improvement"
        title="Download page - make 'raw headers' persist"
      >
        The &apos;Raw Headers&apos; option on the download page will now stay
        how you set it, even if you refresh the page.
      </Issue>
      <Issue type="task" title="add fields to nearshore schema">
        The field, &apos;flowering_shoots&apos; has been added to the Nearshore
        density data.
      </Issue>
      <Issue type="improvement" title="Create unique ID for CTD casts">
        {" "}
        Casts are now assigned a unique hakai id composed of serial number and
        cast start time.
      </Issue>
      <Issue
        type="bug"
        title="Re-enable other_species in nearshore forms processing"
      >
        Other Species fields now correctly populate for nearshore fish and
        invertebrate samples entered via Device Magic forms.{" "}
      </Issue>
      <Issue
        type="new feature"
        title="Tables in Submission Status form data viewer"
      >
        Now you can see a tabular view of your form or excel submission on the
        submission status page.
      </Issue>
      <Issue type="new feature" title="CSV Downloading in portal">
        Now you can choose to download an Excel or a CSV from the portal. Note
        that you can only upload Excel files.
      </Issue>
      <Issue type="bug" title="ctd_unit_pk being set to null">
        Fixed a bug in which updating secchi readings set the ctd unit id to
        null for corresponding ctd drops.{" "}
      </Issue>
      <Issue
        type="bug"
        title='DM zooplankton Form submission Error: "cannot call jsonb_each on a non-object"'
      >
        Fixed bug which caused processing of zooplankton data to crash if
        dominant composition contained a blank entry.{" "}
      </Issue>
      <Issue
        type="improvement"
        title="Add turbidity and support for new ysi file type"
      >
        YSI Data (Turbidity, Barometer, TSS and TDS) from newer ysi units will
        now be auto loaded into the database in the same way as previous units.{" "}
      </Issue>
      <Issue type="improvement" title="Update YSI Calibartion">
        Drop downs are filtered and sub forms show/hide depending on the ysi
        unit selected on ysi calibration forms. This reduce time and confusion
        when filling out ysi calibration forms.{" "}
      </Issue>
      <Issue
        type="sub-task"
        title="Add option to delete solo data through eims excel upload"
      >
        {" "}
        Users can now delete a solo form record by uploading an excel workbook
        to the upload page with a &apos;D&apos; in the &apos;ACTION&apos; field.
      </Issue>
      <Issue type="sub-task" title="Fix casts with lat/long issues">
        {" "}
        Fixed CTD casts where lat and long were swapped or longitude was missing
        negative sign and added constraints to prevent this error in the future.
      </Issue>
      <Issue
        type="bug"
        title="Prevent ctd/solo casts from being annotated with the same form"
      >
        {" "}
        The portal will now warn users when one form has been matched to two or
        more CTD or Solo casts. Each cast should have its own form.
      </Issue>
      <Issue type="bug" title="Process blocked forms during database rebuild">
        Device Magic forms submitted to the database that were blocked due to
        errors are now correctly processed during a database rebuild.{" "}
      </Issue>
      <Issue type="improvement" title="Update TS sample type">
        Refactored Total Solids data structure to better support existing
        workflow. Database now correctly handles samples analyzed at NRAL and
        Hakai.{" "}
      </Issue>
    </Release>

    <Release
      version="v2.3.1"
      date="Oct 24 2018"
      heading="Matilda Effect"
      showVersion={showVersion}
    >
      <Issue
        type="improvement"
        title="Update upload CTD/Solo error message to include filename"
      >
        If a CTD or Solo file fails to upload, the error message will specify
        the filename.
      </Issue>
      <Issue type="bug" title="Upload page letting through bad excel files">
        {" "}
        Fixed an bug where Excel files with errors were allowed to be uploaded
      </Issue>
      <Issue
        type="bug"
        title="Error types not showing up on submission status page"
      >
        On submission status page, Error/Warnings modal, some info in that table
        was not populating.
      </Issue>
      <Issue
        type="bug"
        title="Reordering of forms on the submission status page was broken"
      >
        Fixed issue where clicking save on the reorder forms modal didn&#39;t do
        anything.
      </Issue>
      <Issue type="bug" title="CTD interface fix">
        {" "}
        Replace &#39;Invalid date&#39; in CTD and solo annotation pages with the
        more helpful and accurate &#39;Cast detection failed&#39;.
      </Issue>
      <Issue
        type="improvement"
        title="Move CTD data download documentation to portal for users"
      >
        New FAQ modal on the CTD download page will help onboard new users more
        quickly and could clear up some confusion about features like autofill
        and the differences between different download types.
      </Issue>
      <Issue type="bug" title="Fix searching for multiple CTD surveys bug">
        Combinations of survey options (eg &#39;KWY,QCS_V1,KWY_V2&#39;) removed
        from CTD download page. A drop that is part of multiple surveys can be
        found by searching for either of those surveys.
      </Issue>
      <Issue type="bug" title="TypeError: text.toUpperCase is not a function">
        {" "}
        Fixed issue where adding extra text to the Metadata tab of an Excel
        spreadsheet would cause an error &#39;text.toUpperCase is not a
        function&#39;
      </Issue>
      <Issue
        type="new feature"
        title="Add ysi standards output and processing scripts"
      >
        YSI Standards are now available for download and editing on the Portal
      </Issue>
      <Issue type="bug" title="API array output">
        All array data types have been removed from the portal outputs. Array
        data types are now represented as a comma separated string. This
        standardizes the portal interface as there was previously a mix of
        strings and array data types for lists of data in a field.
      </Issue>
      <Issue type="note" title="Reprocessed Seabird CTD data">
        On Oct 6 2018, the Seabird data finished reprocessing with some updates.
        Users should be aware their CTD data may have been updated if they are
        working with a dataset downloaded prior to this date. The new version
        includes the following features: <br />- RINKO data is processed and
        available in units of mL/L <br />- Transmissometer data is processed and
        beam attenuation is available in units of 1/m <br />- Processing
        generates pdf file with metadata and charts of data before and after
        processing to help QC and review casts <br />- Measurement time added
        for processed data points <br />- Remove hysteresis correction for
        oxygen data <br />- Store Seabird file header as &#39;vendor
        metadata&#39;
        <br />- Record the software version, time processed, and .psa/.xmlcon
        files for each cast
      </Issue>
    </Release>

    <Release
      version="v2.3"
      date="Aug 21st 2018"
      heading="Pratincole Oersted"
      showVersion={showVersion}
    >
      <Issue
        type="bug"
        title="Resolve Seabird transmissometer issues"
        key="EIMS-844"
      >
        Two new sets of xmlcon and psa files were created in order to process
        each of a) the data collected after changes to the transmissometer were
        made and b) the data collected after the instrument was properly
        configured for those changes. All data since May 16 2018 to present are
        now processed.
      </Issue>
      <Issue
        type="bug"
        title="Warnings for uploaded results without samples"
        key="EIMS-868"
      >
        Some filtered sample types did not generate a warning when results were
        added that do not match to an existing sample. HPLC, C13inc, POP,
        POMFAS, and PON_POC will now generate a warning if uploaded results do
        not have a corresponding sample recorded in the database. This will help
        identify issues with lab results returned from external labs as well as
        our own internal processing.
      </Issue>
      <Issue
        type="bug"
        title="Cast without data causing upload to fail"
        key="EIMS-887"
      >
        Fixed CTD cast detection bug where script would crash attempting to
        process a cast without any data points associated with it. Affected file
        018032_20180716_0942.
      </Issue>
      <Issue
        type="bug"
        title="Confusing duplicate samples report when uploading"
        key="EIMS-863"
      >
        During initial validation of uploaded excel files, some columns were not
        included in the duplicate id error message. This was confusing and made
        it difficult to tell which row(s) were in error. The messages returned
        by the validator have been improved. Messages now better indicate which
        columns values are part of the duplication.
      </Issue>
      <Issue
        type="bug"
        title="Improve validation checks for required fields in excel uploads"
        key="EIMS-833"
      >
        Missing required fields will now generate a validation error. Previously
        some columns were not validated if they had been removed from the excel
        file prier to upload.
      </Issue>
      <Issue
        type="bug"
        title="Incorrect staff gauge IDs in sampling event view"
        key="EIMS-895"
      >
        Staff gauge readings in the event sample type, samples field, were
        displaying a sample ID, now they display the numeric reading itself.
      </Issue>
      <Issue
        type="bug"
        title="Secchi comments not populating the quality log"
        key="EIMS-894"
      >
        Excel uploads to the portal for the Secchi data type now populates the
        quality_log correctly. Previously Secchi comments were dropped on
        upload.
      </Issue>
      <Issue
        type="bug"
        title="Can't recall form if device is removed/changes name"
        key="EIMS-893"
      >
        Changing of mobile device names in device magic will no longer prevent
        recalling of forms from the portal.
      </Issue>
      <Issue
        type="bug"
        title="Duplicate ID in excel file upload being caught as error instead of warning"
        key="EIMS-831"
      >
        Duplicate ID&#39;s in excel file uploads are now correctly flagged as
        warnings instead of errors.
      </Issue>
      <Issue type="bug" title="AGOL site intigration" key="EIMS-892, EIMS-908">
        Fixed integration between ArcGIS Online (AGOL) and the portal. Site
        locations and work areas are now correctly populate from the AGOL
        Sampling Locations Layer. This affected several nearshore and FGS sites
        which have now been updated. Handling of failed data requests to AGOL
        has also been improved.
      </Issue>
      <Issue
        type="bug"
        title="Dive not recorded when no fish found"
        key="EIMS-726"
      >
        Nearshore fish and invertebrate transacts with no observations now
        correctly records a transect without observations. Previously no
        transect would have been recorded. This change is retroactive and will
        affect historic data as well.
      </Issue>
      <Issue
        type="bug"
        title="Seagrass canopy height not making it to database from DM form"
        key="EIMS-719"
      >
        Canopy height field in the nearshore seagrass density datasets now
        populates correctly from device magic forms.
      </Issue>
      <Issue
        type="bug"
        title="Seagrass Field Forms sometimes can't be recalled"
        key="EIMS-873"
      >
        There was a bug with recalling forms that has been fixed.
      </Issue>
      <Issue
        type="bug"
        title="Unauthorized access crashed CTD download page"
        key="EIMS-837"
      >
        Fixed a bug where the CTD download page was crashing when a user without
        permissions tried to access it.
      </Issue>

      <Issue
        type="feature"
        title="Create matlab package / module to access our api"
        key="EIMS-816"
      >
        To compliment our existing R and Python packages, we have create a
        matlab package to access the Hakai Data Portal via our API. Users can
        now pull data directly from the portal into existing matlab scripts
        without needing to manually download the data to excel first. To start
        using this package please go to the{" "}
        <a href="https://github.com/HakaiInstitute/hakai-api-client-matlab">
          Hakai API Matlab Client github page
        </a>
        . If you do not already have access to this organizational github repo
        please request access by emailing
        [eims.support@hakai.org|mailto:eims.support@hakai.org]. Matlab API
        request timeout set to 2 minutes. This is a change from the default of 5
        seconds and will accommodate requesting larger datasets.
      </Issue>
      <Issue
        type="feature"
        title="Add output pdf to seabird processing tool"
        key="EIMS-842"
      >
        The Seabird processing script now generates a pdf summary of data and
        processing steps, similar to data product already available for RBR
        data. The file is stored in Amazon S3 and can be downloaded from the
        portal.
      </Issue>
      <Issue
        type="feature"
        title="Add Snow and Ice sampling sources"
        key="EIMS-907"
      >
        Snow (S) and Ice (I) options have been added to the sampling source list
        in freshwater forms. These new sources are now available for use
        throughout the portal.
      </Issue>
      <Issue
        type="feature"
        title="Add c13 incubation result columns"
        key="EIMS-847"
      >
        Place holders for C13 Incubation results have been added to the
        database. The portal will now accept C13 Incubation results uploaded
        using the appropriate results template.
      </Issue>

      <Issue
        type="improvement"
        title="Two step submission for Device Magic Forms"
        key="EIMS-864"
      >
        Device Magic forms now go through a 2-step validation and submission
        process. Any errors generated while sending the form to the Hakai
        database will block the whole form from processing. Forms that do not
        generate errors will be processed normally. This will help to prevent
        duplicate id errors when recalling and resubmitting forms.
      </Issue>
      <Issue
        type="improvement"
        title="Allow raw column names in excel download"
        key="EIMS-835"
      >
        Users can now download excel files with script friendly headers by
        selecting &#39;raw headers&#39; on the data tools download page of the
        portal.
      </Issue>
      <Issue
        type="improvement"
        title="Add download button for uploaded excel files on submission status page"
        key="EIMS-751"
      >
        The ability to download the original excel file associated with a
        submission has been added to the submission page. The button can be
        found in the action menu located on the right hand side of each
        submission row. The menu option will be disabled for submissions that do
        not have a source file to download, such as device magic submissions, or
        were uploaded prior to this feature being added.
      </Issue>
      <Issue
        type="improvement"
        title="Update annotate cast user interface"
        key="EIMS-911"
      >
        Compare form end time for seabird casts and form bottom time for RBR
        casts when annotating.
      </Issue>
      <Issue
        type="improvement"
        title="Add API endpoint for flagged CTD data"
        key="EIMS-891"
      >
        Endpoint added for API users to access flagged CTD data. Details
        available in API documentation.
      </Issue>
      <Issue
        type="improvement"
        title="Download RBR .rsk files from portal"
        key="EIMS-862"
      >
        Add option to download raw RBR files from the download page. Checks S3
        for both rsk (sqlite/binary) or hex (text) format of requested file.
      </Issue>
      <Issue
        type="improvement"
        title="Add uploading CTD excel forms"
        key="EIMS-855"
      >
        Added feature to download, edit, and upload CTD forms with Excel through
        the Data Tools pages on the portal.
      </Issue>
      <Issue
        type="improvement"
        title="Populate pressure transducer depth in datasets"
        key="EIMS-828"
      >
        The Pressure Transducer Depth column for all datasets is now populated
        from the RBR Solo instrument data. The Solo Drops view has also been
        updated to reflect target and instrument depth.
      </Issue>
      <Issue
        type="improvement"
        title="Portal login page 'Please login..' button disabled sometimes"
        key="EIMS-851"
      >
        A bug was fixed where the &#39;Please Login...&#39; button was greyed
        out sometimes.
      </Issue>
      <Issue
        type="improvement"
        title="Add 'duration' option to Tidal Prediction tool"
        key="EIMS-850"
      >
        In the Tidal Prediction tool, you can now specify a duration other than
        7 days. Eg. duration=365 for a year. See the
        <a href="http://hakaiinstitute.github.io/hakai-api/tidal-prediction-tool">
          docs
        </a>
        on github for more info.
      </Issue>
      <Issue
        type="improvement"
        title="Decouple plankton biomass quality log and parent samples"
        key="EIMS-834"
      >
        Quality Level and Quality Log of Plankton Biomass samples are no longer
        set when uploading a Plankton Isotope, Fatty Acid, or Total biomass data
        set. Quality related columns for Plankton Biomass will only be set when
        uploading a Plankton Biomass data set. This removes confusion in the qc
        workflow for biomass samples and insures that QA/QC work is accurately
        recorded.
      </Issue>
      <Issue
        type="improvement"
        title="Update filter wet weight from biomass dataset"
        key="EIMS-827"
      >
        Weight before, weight after, and wet weight can now be updated when
        uploading a zooplankton biomass dataset to the portal.
      </Issue>
      <Issue
        type="improvement"
        title="Add HPLC lab results columns"
        key="EIMS-826"
      >
        Placeholders for HPLC results from the University of Southern California
        (USC) and Department of Fisheries and Oceans - Institute of Ocean
        Sciences (DFO-IOS) have been added to the database. Two templates have
        been created, one for each lab, and added to the{" "}
        <a href="https://drive.google.com/drive/folders/0BwSGouBGB1TXbDJLOXlKR3NSVXM">
          Data Portal Templates
        </a>
        &nbsp;folder. HPLC Results from these labs can now be uploaded to the
        portal.
      </Issue>
      <Issue
        type="improvement"
        title="Create SEMSP Schema, Views, Triggers"
        key="EIMS-758"
      >
        Initial work on Juvenile Salmon Program (formerly SEMSP) data structures
        has been completed and added to the Data Portal. JSP data coming soon.
      </Issue>
      <Issue
        type="improvement"
        title="Change default API access group"
        key="EIMS-886"
      >
        Adjusted portal security to limit access. Read only access is now set
        explicitly rather then being open to all users with a hakai.org account.
      </Issue>
    </Release>

    <Release
      version="v2.2"
      date="May 22nd 2018"
      heading="Hyrax Mnemon"
      showVersion={showVersion}
    >
      <Issue type="feature" title="Add manual flagging for CTD data">
        Can now upload and download an xlsx file that flags individual sensors
        over a period of time. Flagged data is still accessible but will be
        marked in new flagged columns for processed data. Raw data is not
        flagged.
      </Issue>
      <Issue type="bug" title="Ghost duplicates IDs">
        Some excel files were getting duplicate ID errors when there were no
        duplicates in the file.
      </Issue>
      <Issue type="bug" title="Add Bute survey and sites">
        Bute info was missing from device magic and database, impeding CTD
        annotation.
      </Issue>
      <Issue
        type="improvement"
        title="Automatically process RBR file upon annotation"
      >
        RBR processing is set up to run every 5 minutes on Hecate server, so
        processed data will be available almost immediately after the raw files
        are annotated.
      </Issue>
      <Issue type="improvement" title="Add 'date processed' field to ctd casts">
        Keep track of when files were processed in case important changes are
        made and we need to know if a file was processed before or after this
        happened
      </Issue>
      <Issue type="improvement" title="Verify CTD hex or rsk file uploaded">
        CTD files can&#39;t be annotated until the corresponding rsk or hex file
        has been uploaded to S3.
      </Issue>
      <Issue type="feature" title="Saving queries/Reset button">
        Your searches on the Download Page are now saved across sessions - when
        you log back in your search query will be restored. You can reset this
        by clicking the new &#39;Reset&#39; button on the Download page.
      </Issue>
    </Release>
  </div>
);
export default ReleaseNotes;
